import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplateService {
  constructor(protected http: HttpClient) {}

  async getRecLetter(data?: { split: boolean; customerUrl: string; customField: string; inspectionId: number }) {
    return await this.http
      .get<{ html: string[] }>(`${env.APIUrl}/email-template/rec-letter`, { params: data })
      .toPromise();
  }
}
